import Bugsnag from '@bugsnag/js';
import React from 'react';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { getCookieValue } from './utils';

const debug = require('debug')('jp:bugsnag');
const config = require('../../config/config');

const clientCheck = !config.isTesting && process.env.BUGSNAG_JS_API_KEY;

if (clientCheck) {
  /**
   * Bugsnag configuration variables
   */
  Bugsnag.start({
    collectUserIp: true,
    apiKey: process.env.BUGSNAG_JS_API_KEY,
    appVersion: config.appVersion,
    releaseStage: process.env.RELEASE_STAGE,
    enabledReleaseStages: ['staging', 'production'],
    enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'request', 'user'],
    plugins: [new BugsnagPluginReact(React)],
    appType: __CLIENT__ ? 'web' : 'server',
    beforeSend: (event) => {
      if (!__CLIENT__) {
        return;
      }

      event.addMetadata('JustPark', {
        api_session_id: getCookieValue('api_session_id')
      });
    }
  });
}

/**
 * Notify bugsnag of some information
 * @param error
 * @param opts
 */
export const notify = (error, opts) => {
  if (clientCheck) {
    debug('Notify error', {
      error,
      opts
    });
    return Bugsnag.notify(error, opts);
  }

  console.error(error);
  return false;
};

/**
 * Set the current bugsnag userId
 */
export const setUser = (user) => {
  if (clientCheck) {
    debug('Set bugsnag user');

    if (user) {
      Bugsnag.setUser(user.id, user.email, user.firstName);
      return;
    }

    Bugsnag.setUser(Bugsnag.id, null, null);
  }
};

export const leaveBreadcrumb = (name, metadata = {}) => {
  if (clientCheck) {
    debug('Leave Breadcrumb', {
      name,
      metadata
    });
    Bugsnag.leaveBreadcrumb(name, metadata);
  }
};

export default Bugsnag;
